import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { HeadlineXS, LabelM } from '@sorare/core/src/atoms/typography';
import { getHumanReadableSerialNumber } from '@sorare/core/src/lib/cards';

import type { TokenNameCancelSalePopin_anyCard } from './__generated__/index.graphql.ts';

const TokenInfo = styled.div`
  display: flex;
  color: var(--c-nd-600);
`;

type Props = {
  card: TokenNameCancelSalePopin_anyCard;
};

export const TokenNameCancelSalePopin = ({ card }: Props) => {
  const { anyPlayer: player, sportSeason } = card;

  return (
    <>
      <HeadlineXS as="h6">{player.displayName}</HeadlineXS>
      <TokenInfo>
        <LabelM>{sportSeason.name}</LabelM>
        &nbsp;-&nbsp;
        <LabelM>{getHumanReadableSerialNumber(card)}</LabelM>
      </TokenInfo>
    </>
  );
};

TokenNameCancelSalePopin.fragments = {
  anyCard: gql`
    fragment TokenNameCancelSalePopin_anyCard on AnyCardInterface {
      slug
      anyPlayer {
        slug
        displayName
      }
      sportSeason {
        name
      }
      ...getHumanReadableSerialNumber_anyCard
    }
    ${getHumanReadableSerialNumber.fragments.anyCard}
  ` as TypedDocumentNode<TokenNameCancelSalePopin_anyCard>,
};
